import * as React from 'react';
import { observer, Provider } from 'mobx-react';
import { ApplicationPageKey } from '../../types/applicationPages';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observable } from 'mobx';
import { CustomApplicationPageState } from './states/CustomApplicationPageState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Switch, Route } from 'react-router';
import { V3Routes } from '../../routes';
import { ApplicationPageSummaryPane } from '../../components/organisms/application/ApplicationPageSummaryPane';
import { ApplicationPageUserInfoPane } from '../../components/organisms/application/ApplicationPageUserInfoPane';
import { ApplicationPageUserSignInPane } from '../../components/organisms/application/ApplicationPageUserSignInPane';
import { ApplicationPageUserSummaryPane } from '../../components/organisms/application/ApplicationPageUserSummaryPane';
import { ApplicationPagePaymentInfoPane } from '../../components/organisms/application/ApplicationPagePaymentInfoPane';
import { ApplicationPageConfirmationPane } from '../../components/organisms/application/ApplicationPageConfirmationPane';
import { ApplicationPageCompletePaneForShelikes } from '../../components/organisms/application/ApplicationPageCompletePane';
import { ApplicationPageStartDateSelectionPane } from '../../components/organisms/application/ApplicationPageStartDateSelectionPane';
import { ApplicationPageHomeLocationSelectionPane } from '../../components/organisms/application/ApplicationPageHomeLocationSelectionPane';
import { MultiCreatorFullPage } from '../multi_creator/MultiCreatorFullPage';

type Props = {
    match: {
        params: {
            page_key: ApplicationPageKey;
        };
    };
};

@withNavigation(NavigationSpecs.application())
@observer
export class CustomApplicationPage extends React.Component<Props> {
    @observable pageState = new CustomApplicationPageState(GlobalStatesV3.currentUser, GlobalStatesV3.routing);

    componentDidMount() {
        const { page_key } = this.props.match.params;
        this.pageState.init(page_key);
    }

    render() {
        const { page_key } = this.pageState;
        return (
            <Provider applicationState={this.pageState}>
                <Switch>
                    <Route exact path={`/full/multicreators`} component={MultiCreatorFullPage} />
                    <Route
                        exact
                        path={V3Routes.applicationPageSignIn(page_key).stringify()}
                        component={ApplicationPageUserSignInPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageUserInfo(page_key).stringify()}
                        component={ApplicationPageUserInfoPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageUserSummary(page_key).stringify()}
                        component={ApplicationPageUserSummaryPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageStartDateSelect(page_key).stringify()}
                        component={ApplicationPageStartDateSelectionPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageHomeLocationSelect(page_key).stringify()}
                        component={ApplicationPageHomeLocationSelectionPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageSummary(page_key).stringify()}
                        component={ApplicationPageSummaryPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPagePaymentMethod(page_key).stringify()}
                        component={ApplicationPagePaymentInfoPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageConfirmation(page_key).stringify()}
                        component={ApplicationPageConfirmationPane}
                    />
                    <Route
                        exact
                        path={V3Routes.applicationPageComplete(page_key).stringify()}
                        component={ApplicationPageCompletePaneForShelikes}
                    />
                </Switch>
            </Provider>
        );
    }
}
